const SLIDE_INTERVAL_MS = 7000;

export function bannerVideo() {
  const root = document.querySelector("#banner-video");
  if (!root) {
    return;
  }

  const slides = root.querySelectorAll(".banner-video__slide");
  if (slides.length < 2) {
    return;
  }

  if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
    return;
  }

  let index = 0;

  window.setInterval(() => {
    slides[index].classList.remove("active");
    index = (index + 1) % slides.length;
    slides[index].classList.add("active");
  }, SLIDE_INTERVAL_MS);
}
